import App from "@/App.vue";
import { registerPlugins } from "@core/utils/plugins";
import { createApp } from "vue";

// Initialize Firebase FIRST — must run before any plugin that calls getAuth()
import "@/lib/firebase";

// Clear stale Materio/CIT localStorage keys that reference invalid routes (e.g. /admin)
const STALE_KEYS = [
  "materio-isVerticalNavCollapsed",
  "hr-admin-layout-version",
];
STALE_KEYS.forEach((k) => localStorage.removeItem(k));

// Styles
import "@core/scss/template/index.scss";
import "@styles/styles.scss";

// PWA service worker
import { registerSW } from "virtual:pwa-register";
const updateSW = registerSW({
  immediate: true,
  onNeedRefresh() {
    if (
      window.confirm("A new version of UCS is available. Reload now to update?")
    ) {
      updateSW();
    }
  },
  onOfflineReady() {
    console.log("[PWA] App is ready for offline use.");
  },
});

// Create vue app
const app = createApp(App);

// Register plugins
registerPlugins(app);

// Mount vue app
app.mount("#app");
